/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * All supported DID methods. Default is "web".
 */
export type PresentationIssueRequestDidMethod = 'key' | 'web';
export const PresentationIssueRequestDidMethod = {
    Key: 'key',
    Web: 'web',
} as const;
